export function Home() {
  return (
    <main className="p-6">
      <h1 className="text-2xl font-bold text-text-primary mb-4">Welcome to TeamTable</h1>
      <p className="text-text-secondary">
        Get started with payments, table setup, and more.
      </p>
    </main>
  );
}
